import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import firebase from '../../utils/firebase';
import {browserHistory, Link, hashHistory} from 'react-router';
import { fetchUser, updateUser } from '../../actions/firebase_actions';
import {updateModal} from '../../actions/modal';
import { setActive } from '../../actions/ts_active_actions.js';
import PlaybookIcon from '../../images/trickstrat/playbook.png';
import {updateStrat} from '../../actions/ts_userData_actions.js';
import {getGameTitle, getMapTitle} from '../../utils/maps/titleUtil.js';
import logger from '../../actions/log.js';
class StratDetails extends Component {

    constructor(props) {
        super(props);
        this.props.fetchUser();
        this.state = {
            message: '',
        };
          this.update = this.update.bind(this);
    }



    update(userId, stratId, strat){
        event.preventDefault();
        var {currentUser, map, canvas} = this.props;
        const name = this.refs.stratName.value;
        const notes = this.refs.stratNotes.value;
        var canvasUpdate = strat.canvas;
        if (canvas.canvas != null)
        {
          canvasUpdate = canvas.canvas.toDataURL('image/png', 1.0);
        }

        var stratDetails = {
          name: name,
          notes: notes,
          map: strat.map,
          game: strat.game,
          canvas: canvasUpdate,
          createDateTime: strat.createDateTime,
          lastUpdateDateTime: strat.lastUpdateDateTime
        };
        if (name == '')
        {
            this.setState({message: "Give your strat a name!"});
            return;
        }
         this.props.updateStrat(userId, stratId, stratDetails).then((data) => {
             if (data.payload.errorCode) {
                 this.setState({ message: data.payload.errorMessage });
             } else {
                 /*this.setState({
                     message: 'Updated successfuly!',
                 });*/
                // console.log(data.payload.data.strats);
                 //Object.keys(userData.data.strats).length;
                 //{Object.keys(strats).map(item => {return this.playbookLogic(strats[item], item)})}
                 if(stratId == null || stratId == undefined || stratId == '')
                 {
                   logger.logStratSave();
                 }
                 var strats = data.payload.data.strats;
                 {Object.keys(strats).map(item => {return this.setActiveLogic(strats[item], item, name)})}
                 this.props.updateModal(false,null);
             }
       }
     );
     }

    setActiveLogic(strat, stratId, name){
       if (strat.name == name)
       {
         this.props.setActive(strat,stratId);
       }
     }

     handleEnter(event) {
     if (event.keyCode === 13) {
       const form = event.target.form;
       const index = Array.prototype.indexOf.call(form, event.target);
       form.elements[index + 1].focus();
       form.elements[index].blur();
       event.preventDefault();
     }
   }

   handleFocusOut(event) {
       const form = event.target.form;
       const index = Array.prototype.indexOf.call(form, event.target);
       form.elements[index].blur();
       event.preventDefault();
   }

    render() {
      var {currentUser, map} = this.props;
      var strat = {name:"",notes:"", canvas:"", map: map.map, game: map.game, canvas:"", createDateTime: "", lastUpdateDateTime: ""};
      var stratId = null;
      var title = "Add to Playbook";
      var updateButton = "Add to Playbook";
      if (this.props.strat != undefined) {
        strat = this.props.strat;
        title = strat.name;
        updateButton = "Update";
      }
      if (this.props.id != undefined) {
        stratId = this.props.id;
      }

        return (
            <div>
                <form id="frmProfile" role="form" onSubmit={this.onFormSubmit}>
                    <span className="headerText">{title}</span><br/>
                      <span className="bodyText">{getGameTitle(strat.game)} - {getMapTitle(strat.map)}</span>
                      <p className="errorText">
                        {this.state.message}
                      </p>
                   <div className="form-group">
                        <label htmlFor="displayName" className="titleText">Name</label>
                        <input onfocusout={this.handleFocusOut} onKeyDown={this.handleEnter}
                          type="text" maxLength="20" defaultValue={strat.name}
                          className="form-control inputText" ref="stratName" id="stratName" placeholder="Base Strat"
                          name="stratName"
                        />
                    </div>
                    <div className="form-group">
                         <label htmlFor="displayName" className="titleText">Notes</label>
                         <textarea onfocusout={this.handleFocusOut} onKeyDown={this.handleEnter} type="text"  maxLength="250" defaultValue={strat.notes}
                           className="form-control inputText notes" ref="stratNotes" id="stratNotes" placeholder="Notes" name="stratNotes"/>
                     </div>
                    <button type="button" className="buttonStyle" onClick={(event) => {this.update(currentUser.uid, stratId, strat);}}>{updateButton}</button>
                </form>
            </div>
        );
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({ fetchUser, updateUser, updateModal, updateStrat, setActive }, dispatch);
}


function mapStateToProps(state) {
    return { currentUser: state.currentUser, map: state.map, canvas: state.canvas };
}


export default connect(mapStateToProps, mapDispatchToProps)(StratDetails);



// WEBPACK FOOTER //
// ./src/app/components/stratDetails/index.jsx